export default __webpack_public_path__ + "static/media/unouthorized-401.941ab47c.png";